<template>
  <v-container justify-center pa-0 class="text-center">
    <h3>{{ $t("message.not_active") }}</h3>
    <icon-master size="400px" class="rotate" color="error"></icon-master>
  </v-container>
</template>
<script>
import IconMaster from "@/components/displays/icons/IconMaster.vue";
export default {
  components: {
    IconMaster,
  },
};
</script>

<style scoped></style>
